import React, { useContext, useState } from "react";
import {
  TextField,
  Button,
  Container,
  Typography,
  Box,
  Avatar,
  Grid,
  Paper,
  CircularProgress,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Navigate, useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { SEND_REGISTRATION_MAIL } from "../../graphql/gqlUser";
import { UserContext } from "../../contexts/userContext";
import { SnackbarContext } from "../../contexts/snackbarContext";
import { T } from "../../components/T";
import AuthWrapper from "../../components/buildingBlocks/auth-wrapper";

const SignUpPage = () => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [emailHasBeenSent, setEmailHasBeenSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const userContext = useContext(UserContext);

  const [sendRegistrationMail] = useMutation(SEND_REGISTRATION_MAIL);
  const { openErrorSnackbar } = useContext(SnackbarContext);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (email === "") {
      setEmailError(true);
      openErrorSnackbar(<T str="Email is required" />);
      return;
    }

    setLoading(true);

    sendRegistrationMail({ variables: { email } })
      .then(() => {
        setLoading(false);
        setEmailHasBeenSent(true);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  if (userContext.loading) return <div />;
  if (userContext.user.id !== "") {
    return <Navigate to="/" />;
  }
  if (emailHasBeenSent)
    return (
      <AuthWrapper title="Check your email">
        <Box>
          <Typography color="text.secondary" textAlign="center" maxWidth="sm">
            <T str="We’ve sent you a confirmation link. Please check your inbox (or your spam folder) to activate your account." />
          </Typography>
        </Box>
      </AuthWrapper>
    );

  return (
    <AuthWrapper title="Sign Up">
      <Box>
        <Box
          component="form"
          onSubmit={handleSubmit}
          noValidate
          sx={{ mt: 2, width: "100%" }}
        >
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="Email"
            value={email}
            error={emailError}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailError(false);
            }}
            color="secondary"
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={loading}
            color="secondary"
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              <T str="Continue" />
            )}
          </Button>

          <Grid container justifyContent="center">
            <Grid
              item
              sx={{
                cursor: "pointer",
                "&:hover": { textDecoration: "underline" },
              }}
              onClick={() => navigate("/login")}
            >
              <T str="Already have an account? Sign in" />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </AuthWrapper>
  );
};

export default SignUpPage;
